import React from 'react';
import { Navigate } from 'react-router-dom';
import { GenericLoading } from 'components/ui/Loader';
import { useRole } from 'features/auth/contexts/RoleContext';
import { Capability } from 'core/roles';

interface CapabilityRouteProps {
  /** Capacité requise pour accéder à la route (matrice centrale roleCapabilities). */
  capability: Capability;
  children: React.ReactNode;
  /** Redirection si le rôle actif n'a pas la capacité (défaut : accueil). */
  redirectTo?: string;
}

/**
 * Garde de route par capacité de rôle : protège un écran (y compris en accès direct
 * par URL) selon la matrice centrale. Attend le chargement du rôle avant de décider
 * (pas de redirection prématurée sur un F5 / deep link).
 */
export const CapabilityRoute: React.FC<CapabilityRouteProps> = ({
  capability,
  children,
  redirectTo = '/bord'
}) => {
  const { can, isLoading } = useRole();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <GenericLoading loading isParentSized />
      </div>
    );
  }

  if (!can(capability)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
};
